module.exports = __webpack_public_path__ + "static/media/plan-locatie-icon.6df9bac4.svg";